export const SEND_EMAIL_TEXT = Object.freeze({
  invoices: {
    title: 'Enviar factura',
    subtitle: 'Confirma destinatario y mensaje para enviar esta factura de forma segura.',
    closeAriaLabel: 'Cerrar modal de envío',
    summaryPanelTitle: 'Resumen de envío',
    sendPanelTitle: 'Envío',
    summary: {
      sendTypeKey: 'invoice',
      sendTypeLabel: 'Se envía',
      sendTypeValue: 'Factura',
      counterpartLabel: 'Cliente',
      customerLabel: 'Cliente',
      supplierLabel: 'Proveedor',
      counterpartByType: {
        invoice: 'Cliente',
        quote: 'Cliente',
        payment: 'Cliente',
        expense: 'Proveedor',
        fee: 'Proveedor',
      },
      totalLabel: 'Total',
    },
    toLabel: 'Para',
    copyLabel: 'Copia',
    summaryToLabel: 'Para',
    summaryCopyLabel: 'Copia',
    summaryAttachmentsLabel: 'Archivos adjuntos',
    noAttachmentsSelected: 'Sin adjuntos seleccionados',
    noCopiesSelected: 'Sin copia',
    toPlaceholder: 'Escribe un nombre o correo',
    copyPlaceholder: 'Agregar copia',
    removeRecipientLabel: 'Quitar destinatario',
    addExternalRecipientLabel: 'Agregar correo externo',
    recipientsLoadingLabel: 'Cargando contactos...',
    noRecipientMatches: 'No hay contactos coincidentes.',
    messageLabel: 'Mensaje',
    messagePlaceholder: 'Escribe un mensaje breve para el cliente...',
    customizeMoreLabel: 'Personalizar',
    customizeLessLabel: 'Ocultar opciones',
    editorUndoLabel: 'Atrás',
    editorRedoLabel: 'Adelante',
    editorBoldLabel: 'Negritas',
    editorItalicLabel: 'Cursivas',
    editorJustifyLabel: 'Justificar',
    editorUnderlineLabel: 'Subrayado',
    editorBulletListLabel: 'Lista',
    editorOrderedListLabel: 'Lista numerada',
    editorHeadingLabel: 'Encabezado',
    editorFontSizeLabel: 'Tamaño',
    editorColorLabel: 'Color',
    editorBackgroundColorLabel: 'Color de fondo',
    editorClearFormattingLabel: 'Limpiar formato',
    attachDocumentsButtonLabel: 'Documentos adicionales',
    attachInvoicesButtonLabel: 'Factura adicional',
    closeSectionLabel: 'Cerrar',
    documentAttachmentsTitle: 'Documentos adicionales',
    documentModeExistingLabel: 'Existente',
    documentModeNewLabel: 'Nuevo',
    selectFileLabel: 'Seleccionar archivo',
    noFileSelectedLabel: 'Ningún archivo seleccionado',
    addAnotherFileLabel: 'Agregar archivo',
    invoiceAttachmentsTitle: 'Facturas adicionales',
    removeAttachmentLabel: 'Quitar adjunto',
    emptyCopiesText: 'No hay colaboradores disponibles para copiar.',
    emptyAttachmentsText: 'No hay documentos adicionales disponibles.',
    cancelLabel: 'Cancelar',
    submitLabel: 'Enviar',
    submittingLabel: 'Enviando factura...',
    messageLoadingText: 'Cargando...',
    toasts: {
      submitted: 'La factura se envió correctamente.',
      failed: 'No fue posible enviar la factura. Intenta nuevamente.',
    },
    defaultMessage: () => 'La factura se envió correctamente.',
  },
  paymentReceipts: {
    title: 'Enviar pago',
    subtitle: 'Confirma destinatario y mensaje para enviar este pago de forma segura.',
    closeAriaLabel: 'Cerrar modal de envío',
    summaryPanelTitle: 'Resumen de envío',
    sendPanelTitle: 'Envío',
    summary: {
      sendTypeKey: 'payment_receipt',
      sendTypeLabel: 'Se envía',
      sendTypeValue: 'Pago',
      counterpartLabel: 'Cliente',
      customerLabel: 'Cliente',
      supplierLabel: 'Proveedor',
      counterpartByType: {
        payment_receipt: 'Cliente',
        payment: 'Cliente',
      },
      totalLabel: 'Total',
    },
    toLabel: 'Para',
    copyLabel: 'Copia',
    summaryToLabel: 'Para',
    summaryCopyLabel: 'Copia',
    summaryAttachmentsLabel: 'Archivos adjuntos',
    noAttachmentsSelected: 'Sin adjuntos seleccionados',
    noCopiesSelected: 'Sin copia',
    toPlaceholder: 'Escribe un nombre o correo',
    copyPlaceholder: 'Agregar copia',
    removeRecipientLabel: 'Quitar destinatario',
    addExternalRecipientLabel: 'Agregar correo externo',
    recipientsLoadingLabel: 'Cargando contactos...',
    noRecipientMatches: 'No hay contactos coincidentes.',
    messageLabel: 'Mensaje',
    messagePlaceholder: 'Escribe un mensaje breve para el cliente...',
    customizeMoreLabel: 'Personalizar',
    customizeLessLabel: 'Ocultar opciones',
    editorUndoLabel: 'Atrás',
    editorRedoLabel: 'Adelante',
    editorBoldLabel: 'Negritas',
    editorItalicLabel: 'Cursivas',
    editorJustifyLabel: 'Justificar',
    editorUnderlineLabel: 'Subrayado',
    editorBulletListLabel: 'Lista',
    editorOrderedListLabel: 'Lista numerada',
    editorHeadingLabel: 'Encabezado',
    editorFontSizeLabel: 'Tamaño',
    editorColorLabel: 'Color',
    editorBackgroundColorLabel: 'Color de fondo',
    editorClearFormattingLabel: 'Limpiar formato',
    attachDocumentsButtonLabel: 'Documentos adicionales',
    attachInvoicesButtonLabel: 'Factura adicional',
    closeSectionLabel: 'Cerrar',
    documentAttachmentsTitle: 'Documentos adicionales',
    documentModeExistingLabel: 'Existente',
    documentModeNewLabel: 'Nuevo',
    selectFileLabel: 'Seleccionar archivo',
    noFileSelectedLabel: 'Ningún archivo seleccionado',
    addAnotherFileLabel: 'Agregar archivo',
    invoiceAttachmentsTitle: 'Facturas adicionales',
    removeAttachmentLabel: 'Quitar adjunto',
    emptyCopiesText: 'No hay colaboradores disponibles para copiar.',
    emptyAttachmentsText: 'No hay documentos adicionales disponibles.',
    cancelLabel: 'Cancelar',
    submitLabel: 'Enviar',
    submittingLabel: 'Enviando pago...',
    messageLoadingText: 'Cargando...',
    toasts: {
      submitted: 'El pago se envió correctamente.',
      failed: 'No fue posible enviar el pago. Intenta nuevamente.',
    },
    defaultMessage: () => 'Compartimos el comprobante de pago emitido y su archivo PDF adjunto.',
  },
  expenseReceipts: {
    title: 'Enviar pago de egreso',
    subtitle: 'Confirma destinatario y mensaje para enviar este pago de egreso de forma segura.',
    closeAriaLabel: 'Cerrar modal de envío',
    summaryPanelTitle: 'Resumen de envío',
    sendPanelTitle: 'Envío',
    summary: {
      sendTypeKey: 'expense_receipt',
      sendTypeLabel: 'Se envía',
      sendTypeValue: 'Pago de egreso',
      counterpartLabel: 'Proveedor',
      customerLabel: 'Cliente',
      supplierLabel: 'Proveedor',
      counterpartByType: {
        expense_receipt: 'Proveedor',
      },
      totalLabel: 'Total',
    },
    toLabel: 'Para',
    copyLabel: 'Copia',
    summaryToLabel: 'Para',
    summaryCopyLabel: 'Copia',
    summaryAttachmentsLabel: 'Archivos adjuntos',
    noAttachmentsSelected: 'Sin adjuntos seleccionados',
    noCopiesSelected: 'Sin copia',
    toPlaceholder: 'Escribe un nombre o correo',
    copyPlaceholder: 'Agregar copia',
    removeRecipientLabel: 'Quitar destinatario',
    addExternalRecipientLabel: 'Agregar correo externo',
    recipientsLoadingLabel: 'Cargando contactos...',
    noRecipientMatches: 'No hay contactos coincidentes.',
    messageLabel: 'Mensaje',
    messagePlaceholder: 'Escribe un mensaje breve para el proveedor...',
    customizeMoreLabel: 'Personalizar',
    customizeLessLabel: 'Ocultar opciones',
    editorUndoLabel: 'Atrás',
    editorRedoLabel: 'Adelante',
    editorBoldLabel: 'Negritas',
    editorItalicLabel: 'Cursivas',
    editorJustifyLabel: 'Justificar',
    editorUnderlineLabel: 'Subrayado',
    editorBulletListLabel: 'Lista',
    editorOrderedListLabel: 'Lista numerada',
    editorHeadingLabel: 'Encabezado',
    editorFontSizeLabel: 'Tamaño',
    editorColorLabel: 'Color',
    editorBackgroundColorLabel: 'Color de fondo',
    editorClearFormattingLabel: 'Limpiar formato',
    attachDocumentsButtonLabel: 'Documentos adicionales',
    attachInvoicesButtonLabel: 'Factura adicional',
    closeSectionLabel: 'Cerrar',
    documentAttachmentsTitle: 'Documentos adicionales',
    documentModeExistingLabel: 'Existente',
    documentModeNewLabel: 'Nuevo',
    selectFileLabel: 'Seleccionar archivo',
    noFileSelectedLabel: 'Ningún archivo seleccionado',
    addAnotherFileLabel: 'Agregar archivo',
    invoiceAttachmentsTitle: 'Facturas adicionales',
    removeAttachmentLabel: 'Quitar adjunto',
    emptyCopiesText: 'No hay colaboradores disponibles para copiar.',
    emptyAttachmentsText: 'No hay documentos adicionales disponibles.',
    cancelLabel: 'Cancelar',
    submitLabel: 'Enviar',
    submittingLabel: 'Enviando pago de egreso...',
    messageLoadingText: 'Cargando...',
    toasts: {
      submitted: 'El pago de egreso se envió correctamente.',
      failed: 'No fue posible enviar el pago de egreso. Intenta nuevamente.',
    },
    defaultMessage: () => 'Compartimos el comprobante de pago de egreso emitido y su archivo PDF adjunto.',
  },
  simpleNotes: {
    title: 'Enviar nota simple',
    subtitle: 'Confirma destinatario y mensaje para enviar esta nota simple de forma segura.',
    closeAriaLabel: 'Cerrar modal de envío',
    summaryPanelTitle: 'Resumen de envío',
    sendPanelTitle: 'Envío',
    summary: {
      sendTypeKey: 'simple_note',
      sendTypeLabel: 'Se envía',
      sendTypeValue: 'Nota simple',
      counterpartLabel: 'Cliente',
      customerLabel: 'Cliente',
      supplierLabel: 'Proveedor',
      counterpartByType: {
        simple_note: 'Cliente',
      },
      totalLabel: 'Total',
    },
    toLabel: 'Para',
    copyLabel: 'Copia',
    summaryToLabel: 'Para',
    summaryCopyLabel: 'Copia',
    summaryAttachmentsLabel: 'Archivos adjuntos',
    noAttachmentsSelected: 'Sin adjuntos seleccionados',
    noCopiesSelected: 'Sin copia',
    toPlaceholder: 'Escribe un nombre o correo',
    copyPlaceholder: 'Agregar copia',
    removeRecipientLabel: 'Quitar destinatario',
    addExternalRecipientLabel: 'Agregar correo externo',
    recipientsLoadingLabel: 'Cargando contactos...',
    noRecipientMatches: 'No hay contactos coincidentes.',
    messageLabel: 'Mensaje',
    messagePlaceholder: 'Escribe un mensaje breve para el cliente...',
    customizeMoreLabel: 'Personalizar',
    customizeLessLabel: 'Ocultar opciones',
    editorUndoLabel: 'Atrás',
    editorRedoLabel: 'Adelante',
    editorBoldLabel: 'Negritas',
    editorItalicLabel: 'Cursivas',
    editorJustifyLabel: 'Justificar',
    editorUnderlineLabel: 'Subrayado',
    editorBulletListLabel: 'Lista',
    editorOrderedListLabel: 'Lista numerada',
    editorHeadingLabel: 'Encabezado',
    editorFontSizeLabel: 'Tamaño',
    editorColorLabel: 'Color',
    editorBackgroundColorLabel: 'Color de fondo',
    editorClearFormattingLabel: 'Limpiar formato',
    attachDocumentsButtonLabel: 'Documentos adicionales',
    attachInvoicesButtonLabel: 'Factura adicional',
    closeSectionLabel: 'Cerrar',
    documentAttachmentsTitle: 'Documentos adicionales',
    documentModeExistingLabel: 'Existente',
    documentModeNewLabel: 'Nuevo',
    selectFileLabel: 'Seleccionar archivo',
    noFileSelectedLabel: 'Ningún archivo seleccionado',
    addAnotherFileLabel: 'Agregar archivo',
    invoiceAttachmentsTitle: 'Facturas adicionales',
    removeAttachmentLabel: 'Quitar adjunto',
    emptyCopiesText: 'No hay colaboradores disponibles para copiar.',
    emptyAttachmentsText: 'No hay documentos adicionales disponibles.',
    cancelLabel: 'Cancelar',
    submitLabel: 'Enviar',
    submittingLabel: 'Enviando nota simple...',
    messageLoadingText: 'Cargando...',
    toasts: {
      submitted: 'La nota simple se envió correctamente.',
      failed: 'No fue posible enviar la nota simple. Intenta nuevamente.',
    },
    defaultMessage: () => 'Compartimos la nota simple emitida y su archivo PDF adjunto.',
  },
});
